import { gql } from '@biletiniz/apollo';

export const UPDATE_PASSWORD = gql`
  mutation updatePassword($oldPassword: String!, $newPassword: String!) {
    updatePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
      message
      status
      token {
        accessToken
        accessTokenExpiresAt
        refreshToken
        refreshTokenExpiresAt
        user {
          name
          surname
          email
          phoneNumber
          balance {
            amount
            currency
          }
        }
      }
    }
  }
`;
